<h1 mat-dialog-title>Einladungen/Absagen ausführen</h1>

<div mat-dialog-content>
  <p *ngIf="cycle as c">
    Für den Pitch <b>{{ c.name }}</b> am <b>{{ c.pitchDate | moment: 'date' }}</b> sind folgende Änderungen vorgemerkt:
  </p>

  <table mat-table #table matSort [dataSource]="updates$" class="mat-elevation-z8">
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let u; columns: displayedColumns"></tr>

    <ng-container matColumnDef="product">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="product">Produkt</th>
      <td mat-cell *matCellDef="let u">{{ u.productName }}</td>
    </ng-container>

    <ng-container matColumnDef="startup">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="startup">Start-up</th>
      <td mat-cell *matCellDef="let u">{{ u.startupName }}</td>
    </ng-container>

    <ng-container matColumnDef="change">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="newStatus">Änderung</th>
      <td mat-cell *matCellDef="let u">{{ u.oldStatus | productStateTranslate }} → {{ u.newStatus | productStateTranslate }}</td>
    </ng-container>

    <ng-container matColumnDef="sendMail">
      <th mat-header-cell *matHeaderCellDef>Automatische Mail</th>
      <td mat-cell *matCellDef="let startup">
        <mat-checkbox [checked]="sendMailMap.get(startup.productId)" (change)="updateMailMap(startup.productId, $event.checked)"> </mat-checkbox>
      </td>
    </ng-container>
  </table>

  <div>
    <form [formGroup]="textForm">
      <mat-form-field style="width: 100%" class="d-none" [class.d-block]="updatesContainInvite$ | async">
        <textarea matInput formControlName="invited" placeholder="Zusatzinformationen Einladungen"></textarea>
      </mat-form-field>
      <br />

      <mat-form-field style="width: 100%" class="d-none" [class.d-block]="updatesContainNotInvite$ | async">
        <textarea matInput formControlName="notInvited" placeholder="Zusatzinformationen Absagen"></textarea>
      </mat-form-field>
    </form>
  </div>

  <p>Beim Klick auf "Jetzt ausführen" wird der Status für die angegebenen Start-ups geändert und entsprechende E-Mails versendet.</p>
</div>
<div mat-dialog-actions>
  <markant-button (click)="cancel()" class="pink button">Abbrechen</markant-button>
  <div style="flex-grow: 1">
    <!-- spacer -->
  </div>
  <markant-button (click)="execute()" class="primary pink button">Jetzt ausführen</markant-button>
</div>
